import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import useTheme from "@material-ui/core/styles/useTheme";
import Toolbar from "@material-ui/core/Toolbar";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import Person from "@material-ui/icons/Person";
import React from "react";
import { queryCache, useQuery } from "react-query";
import { NavLink, useHistory } from "react-router-dom";

import { SIDEBAR_WIDTH } from "../../app/theme";
import { QUERY_AUTH } from "../../services/auth/queries";
import { STORAGE_KEYS } from "../../utils/constants";

const Header = () => {
  const history = useHistory();
  const theme = useTheme();
  const { data: user } = useQuery(QUERY_AUTH);

  const logout = () => {
    queryCache.removeQueries(QUERY_AUTH.queryKey);
    localStorage.removeItem(STORAGE_KEYS.AUTH_TOKEN);
    history.push("/");
  };

  return (
    <AppBar position="relative" style={{ paddingLeft: SIDEBAR_WIDTH - theme.spacing(3) }}>
      <Toolbar color="#fff">
        <Grid item style={{ flexGrow: 1, paddingLeft: theme.spacing(3) }}>
          <Grid container justify="flex-end" spacing={1}>
            <Grid item>
              <NavLink to="/users/me" style={{ color: "#fff", textDecoration: "none" }}>
                <Button variant="text" color="inherit" style={{ textTransform: "none" }}>
                  <Person style={{ marginRight: 6 }} />
                  {user.name_first} {user.name_last}
                </Button>
              </NavLink>
            </Grid>

            <Grid item>
              <Button variant="text" color="inherit" onClick={logout}>
                <ExitToAppIcon style={{ marginRight: 6 }} />
                Выход
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
